import React from 'react';

export const Bedrift = () => {
  return (
    <>
      Bedrift page
    </>
  )
}